import React from 'react';
import { FunctionComponent } from 'react';
import { BoardListsWrapper } from './BoardListsWrapper';
import { BoardHeader } from './BoardHeader';
import { IBoardProps } from './types';

export const Board: FunctionComponent<IBoardProps> = ({
  boardId,
  boardListIds,
  meetingId,
  unextendableBoardList,
  isAdmin,
}) => {
  return (
    <div>
      <BoardHeader boardId={boardId} meetingId={meetingId} />
      <BoardListsWrapper
        boardListIds={boardListIds}
        boardId={boardId}
        meetingId={meetingId}
        unextendableBoard={unextendableBoardList}
        isAdmin={isAdmin}
      />
    </div>
  );
};
